export default __webpack_public_path__ + "static/media/1753.06573874.png";